import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import { makeStyles } from "@material-ui/core/styles";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import TextField from "@material-ui/core/TextField";
import Input from "@material-ui/core/InputAdornment";
import jsonTemplateService from "../services/JsonTemplateService";
import notify from "../utils/notifier";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Util from "../utils/Util";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import {SUPPORTED_FILE_FOR_TEMPLATE_CREATION} from '../utils/constants';

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1)
  },
  input: {
    display: "none"
  },
  floatLeft: {
    float: "left"
  },
  formContainer: {
    display: "flex",
    flexWrap: "wrap"
  },
  flexItem: {
    flex: 1
  },
  textField: {
    paddingRight: theme.spacing(4)
  },
  hiddenField: {
    visibility: "hidden",
    padding: "20px"
  },
  fileUploadWrapper: {
    background: "#f8f8f8",
    minHeight: "75px",
    display: "flex",
    alignItems: "center",
    borderRadius: "5px",
    padding: "20px"
  }
}));

function PaperComponent(props) {
  return (
    <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default function EditModal(props) {
  const [t, i18n] = useTranslation();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const { useState } = React;
  const [templateName, setTemplateName] = useState("");
  const [templateCode, setTemplateCode] = useState("");
  const [orgId, setOrgId] = useState("");
  const [appId, setAppId] = useState("");
  const [metadata, setMetadata] = useState("");
  const [file, setFile] = useState("");
  const[json,setJson] = useState();

  const setData = data => {
    setTemplateName({ value: data.templateName });
    setOrgId({ value: data.organizationId });
    setTemplateCode({ value: data.code}); 
    setAppId({ value: data.applicationId });
    setJson({ value: props.json })
    let isMetadataObj = typeof data.metadata === "object" ? true : false;
    if (isMetadataObj) {
      let metadataStr = Util.toString(data.metadata);
      setMetadata({ value: metadataStr });
    } else {
      setMetadata({ value: data.metadata });
    }
    // setFile(data.file);
  };

  const handleClickOpen = () => {
    if (props.mode === "edit") {
      setData(props.data);
    }
    else{
        setJson(props.json);
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickDeleteFile = () => {
    setFile({ value: null });
  };

  const validateOnFileChange = _file => {

    if (!_file) return;

    let emailTemplate = false;
    if (!(props.service === undefined) && props.service === "email") {
      emailTemplate = true;
    }

    if (_file) {
      let reg;
      let errorMessage = "";

      if (emailTemplate) {
        reg = /(.*?)\.(html)$/;
        errorMessage = "Only .html file is supported";
      } else {
        reg = /(.*?)\.(docx|doc|html|zpl)$/;
        errorMessage = `Only ${SUPPORTED_FILE_FOR_TEMPLATE_CREATION.join(', ')} files are accepted`;
      }

      if (!_file.name.match(reg)) {
        notify({
          type: "error",
          message: errorMessage
        });
        return;
      }
    }
  };

  const buildRequestObj = () => {
    let invalidFields = [];
    let isEditMode = props.mode === "edit" ? true : false;

    invalidFields = validateFields(templateName, orgId, appId);
    if (invalidFields.length) {
      notify({
        type: "error",
        message:
          "Invalid Fields(" +
          invalidFields.length +
          "): Please provide valid input."
      });
      return;
    }

    var formData = new FormData();
    formData.append("templateName", templateName.value);
    formData.append("organizationId", orgId.value);
    formData.append("applicationId", appId.value);
    formData.append("templateCode",templateCode.value)
    isEditMode?(formData.append("json", JSON.stringify(json.value)))
    :(formData.append("json", JSON.stringify(json)));
    // let metadataJson = Util.toJSONObj(metadata.value);
    //formData.append("metadata", metadata.value);
    return formData;
  };

const history = useHistory();
function onUploadComplete(data){
    history.push("/jsonTemplates");
}

  const handleSubmit = () => {
    let formData = buildRequestObj();
        if (!formData) return;
        let service;
        service = jsonTemplateService;
        service.uploadJsonTemplate(formData).then(
          response => {
            notify({
              type: "success",
              message: "Successfully created template file.."
            });
            onUploadComplete({ data: response.data, mode: "create" });
          },
          error => {
            notify({
              type: "error",
              message: "Error: " + error.response.data.errorCode
            });
          }
        );
  };

  const handleEditClick = () => {
      history.push("/createTemplate",{'data':props.data});
  }

  const handleUpdate = () => {
    let formData = buildRequestObj();
    if (!formData) return;

    jsonTemplateService.updateJsonTemplate(props.data.id, formData).then(
        response => {
          var formDataObj = {};
          formData.forEach((value, key) => {
            formDataObj[key] = value;
          });
          onUploadComplete({
            data: formDataObj,
            mode: "edit",
            recordId: props.data.id
          });
          notify({
            type: "success",
            message: "Successfully updated template file.."
          });
          handleClose();
        },
        error => {
          notify({
            type: "error",
            message: "Error: " + error.response.data.errorCode
          });
        }
      );
  };

  const validateFields = (...fields) => {
    let errorFields = [];
    fields.forEach(field => {
      if (!field.value || typeof field.value === "undefined") {
        errorFields.push(field);
      }
    });
    return errorFields;
  };
  const gettemplateIdentifier = (props) => {
    let templateString = props.service === undefined ? props.data.templateId : props.data.templateName;
    return templateString;
  }


  return (
    <div>
      {props.mode === "create" ? (
        <Button
          color="primary"
          className={classes.button}
          onClick={handleClickOpen}
          startIcon={<CloudUploadIcon />}
        >
          {t("Create")}
        </Button>
      ) : (
          <Button
          color="primary"
          className={classes.button}
          onClick={handleClickOpen}
          startIcon={<EditIcon />}
        >
          {t("Update")}
        </Button>
        )}

      <Dialog open={open} PaperComponent={PaperComponent}>
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {props.mode === "edit"
            ? t("Modify Template")
            : t("Upload a new Template")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("Please enter all the required fields.")}
          </DialogContentText>
          <div className={classes.formContainer}>
            <div className={classes.flexItem}>
              <TextField
                id="standard-basic"
                className={classes.textField}
                label={t("Template Name")}
                placeholder={props.title}
                margin="normal"
                type={'text'}
                required
                fullWidth
                value={templateName.value}
                onChange={e => {
                  const val = e.target.value;
                  setTemplateName(prevState => {
                    return { ...prevState, value: val };
                  });
                }}
              />
            </div>
            <div className={classes.flexItem}>
              <TextField
                id="standard-basic"
                required
                type={'text'}
                className={classes.textField}
                label={t("Organization ID")}
                margin="normal"
                fullWidth
                value={orgId.value}
                onChange={e => {
                  const val = e.target.value;
                  setOrgId(prevState => {
                    return { ...prevState, value: val };
                  });
                }}
              />
            </div>
          </div>
          <div className={classes.formContainer}>
            <div className={classes.flexItem}>
              <TextField
                id="standard-multiline-static"
                label={t("Application ID")}
                required
                type={'text'}
                className={classes.textField}
                margin="normal"
                fullWidth
                value={appId.value}
                onChange={e => {
                  const val = e.target.value;
                  setAppId(prevState => {
                    return { ...prevState, value: val };
                  });
                }}
              />

            </div>
            <div className={classes.flexItem}>
              <TextField
                id="standard-basic"
                required
                type={'text'}
                className={classes.textField}
                label={t("Template Code")}
                margin="normal"
                fullWidth
                value={templateCode.value}
                onChange={e => {
                  const val = e.target.value;
                  setTemplateCode(prevState => {
                    return { ...prevState, value: val };
                  });
                }}
              />
            </div>
          </div>
          
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="secondary">
            {t("CANCEL")}
          </Button>
          {props.mode === "edit" ? (
            <Button onClick={handleUpdate} color="primary">
              {t("UPDATE")}
            </Button>
          ) : (
              <Button onClick={handleSubmit} color="primary">
                {t("SUBMIT")}
              </Button>
            )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
